// One number: which page view we're on.
//
// Anything that keeps working after it has painted — the shortlist poller, waiting for matching to
// finish — captures this when it starts and checks it before it touches the screen again. Navigate
// away and the number moves, so the old work quietly stops instead of painting itself over the page
// the person is actually looking at.

let generation = 0;

/** Called by the router, once per page view. */
export const leavePage = (): number => ++generation;

/** Captured by anything long-running, and compared before it paints. */
export const pageView = (): number => generation;
